/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubjectModel, { STATE_LABELS } from 'cio/models/subject';

interface JourneyLabelArgs {
  subject: SubjectModel;
}

const DEFAULT_STATE = { label: '…', className: 'text-muted' };

export default class JourneyLabel extends Component<JourneyLabelArgs> {
  get state() {
    return STATE_LABELS[this.args.subject.subjectState] ?? DEFAULT_STATE;
  }
}
